import { ReactFlowProvider } from "@xyflow/react";

import { DnDProvider } from "./Editor/DnDContext";
import { UpdateCoursesForm } from "./UpdateCoursesForm";

export const UpdateCoursesFormWrapper = () => {
	return (
		<ReactFlowProvider>
			<DnDProvider>
				<UpdateCoursesForm />
			</DnDProvider>
		</ReactFlowProvider>
	);
};
